import "rxjs/add/operator/mergeMap";
import omit from "lodash/omit";
import { Types, Creators } from "../reducer";
import { normalizeEmail, normalizePhone } from "../../common/normalize";

import * as firebase from "firebase";

export default action$ =>
  action$.ofType(Types.SAVE_CUSTOMER).mergeMap(action => {
    const customer = omit(action.customer, "key");
    if (customer.email) customer.email = normalizeEmail(customer.email);
    if (customer.phone) customer.phone = normalizePhone(customer.phone);

    return firebase
      .database()
      .ref(`customers/${action.customer.key}`)
      .update(customer)
      .then(() => Creators.showMessage("Save Customer Successfully."))
      .catch(() => Creators.showMessage("Save Customer Failed"));
  });



// WEBPACK FOOTER //
// ./src/customer/epics/saveCustomer.js